import { createFileRoute, Outlet, Link, redirect, useRouterState } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";

import { isCurrentUserAdmin } from "@/lib/admin-auth.functions";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authenticated/admin")({
  ssr: false,
  beforeLoad: async () => {
    try {
      const res = await isCurrentUserAdmin();
      if (!res.isAdmin) throw redirect({ to: "/" as any });
    } catch (e) {
      if (e && typeof e === "object" && "to" in (e as any)) throw e;
      throw redirect({ href: "/auth/", search: {} });
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isActive = (p: string) => pathname.startsWith(p);
  const checkAdmin = useServerFn(isCurrentUserAdmin);
  useQuery({ queryKey: ["isAdmin"], queryFn: () => checkAdmin(), staleTime: 60_000 });

  async function signOut() {
    const { supabase } = await import("@/integrations/supabase/client");
    await supabase.auth.signOut();
    window.location.assign("/auth");
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3">
          <div className="flex items-center gap-6">
            <Link to="/admin/blog" className="text-sm font-semibold text-foreground">
              RESTORE Admin
            </Link>
            <nav className="flex items-center gap-4 text-sm">
              <Link
                to="/admin/blog"
                className={isActive("/admin/blog") ? "font-medium text-foreground" : "text-muted-foreground hover:text-foreground"}
              >
                Posts
              </Link>
              <Link
                to="/admin/taxonomy"
                className={isActive("/admin/taxonomy") ? "font-medium text-foreground" : "text-muted-foreground hover:text-foreground"}
              >
                Authors & taxonomy
              </Link>
              <Link
                to="/admin/images"
                className={isActive("/admin/images") ? "font-medium text-foreground" : "text-muted-foreground hover:text-foreground"}
              >
                Image sources
              </Link>
            </nav>
          </div>
          <Button variant="outline" size="sm" onClick={signOut}>Sign out</Button>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}